import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

export type Energielabel = 'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G' | 'A_' | 'A__' | 'A___' | 'A____';

@Component
export class AppEnergielabelComponent extends Vue {
  @Prop()
  public label!: Energielabel;

  public get resolvedLabel(): string {
    const validLabels = 'ABCDEFGA_A__A___A____';
    if (this.label === 'A_') {
      return 'A+';
    } else if (this.label === 'A__') {
      return 'A++';
    } else if (this.label === 'A___') {
      return 'A+++';
    } else if (this.label === 'A____') {
      return 'A++++';
    } else {
      return validLabels.indexOf(this.label) < 0 ? '?' : this.label;
    }
  }

  public get title(): string {
    return `Energielabel ${this.label}`;
  }

  public get labelClass(): string {
    return `energielabel-${(this.label || '').charAt(0).toLowerCase()}`;
  }
}

export default AppEnergielabelComponent;
